import * as _ from "lodash";
import { Component, Renderer2 } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { filter, first, takeUntil, map } from 'rxjs/operators';

import { GamesStore } from "../core-services/games/games.store";
import { Game } from "../core-services/games/games.model";
import { GameDetails } from './games-details.model';
import { environment } from '../../environments/environment';
import { BaseComponent } from '../base.component';
import { FavoritesStore } from '../core-services/favorites/favorites.store';
import { ImgRGB, PrefixLangs } from '../core-services/core.models';
import { UserStore } from '../core-services/user/user.store';
import { VisitorStore } from "../core-services/visitor/visitor.store";

export const GAMES_DETAILS_SELECTOR = 'whg-games-details';
@Component({
  selector: GAMES_DETAILS_SELECTOR,
  templateUrl: './games-details.component.html',
  styleUrls: ['./games-details.component.scss']
})
export class GamesDetailsComponent extends BaseComponent {
  gameDetailsConfig: GameDetails;

  gameDetails$: Observable<Game[]> = this.gameStore.gameDetails$.pipe(filter(x => !!x));
  selectedGameLaunchCode: string;
  environment = environment;
  loggedIn: boolean = false;
  isOpenedFromSliderAndModalOpened: boolean = false;
  imgSrc: string;


  constructor(
    public activeModal: NgbActiveModal,
    public favoriteStore: FavoritesStore,
    private gameStore: GamesStore,
    private renderer: Renderer2,
    private userStore: UserStore,
    private visitorStore: VisitorStore,
  ) {
    super(PrefixLangs.GameDetails);
  }

  ngOnInit() {
    this.visitorStore.jurisdication$.pipe(takeUntil(this.destroy$)).subscribe(jurisdiction => {
      /*
      * Set language if any from the cookie, get configuration and listen for language switching
      */
      this.jurisdiction = jurisdiction;
      super.ngOnInit();
      this.config$.pipe(takeUntil(this.destroy$)).subscribe((gameDetailsConfig: GameDetails) => {
        this.gameDetailsConfig = gameDetailsConfig;
      });
    });

    this.userStore.addUserDetails(this.coreService.getUserDetails());
    const userDetails$ = this.userStore.userDetails$;
    userDetails$.pipe(takeUntil(this.destroy$), filter(x => !!x && !_.isNil(x.userid))).subscribe(() => {
      this.loggedIn = true;
    });

    this.gameDetails$.pipe(takeUntil(this.destroy$), filter(x => !!x)).subscribe(gameDetails => {
      this.getImagePath(gameDetails[0].image);
    });
  }

  closeModal(): void {
    this.activeModal.close();
  }

  getImagePath(imgCode: string): void {
    const screenWidth: number = this.coreService.getScreenWidthFromWindow();
    if (screenWidth > 700) {
      this.imgSrc = this.coreService.getDesktopImagePath(imgCode);
    } else {
      this.imgSrc = this.coreService.getImagePath(imgCode);
    }
  }

  showVolatility(volatility: string): string {
    return volatility[0].toUpperCase() + volatility.slice(1).toLowerCase();
  }

  updateFavorite(game: Game): void {
    this.isFavorite(game).pipe(first()).subscribe(isFavorite => {
      if (isFavorite) {
        this.favoriteStore.removeFavorite(game).pipe(first()).subscribe();
      } else {
        this.favoriteStore.addFavorite(game).pipe(first()).subscribe();
      }
    })
  }

  isFavorite(game: Game): Observable<boolean> {
    this.favoriteStore.getFavorites();
    return this.favoriteStore.favorites$.pipe(
      takeUntil(this.destroy$),
      filter(x => !!x),
      map(favoriteSet => favoriteSet.has(game)),
    );
  }

  setBackground(imgCode: string): void {
    const url = this.coreService.getImagePath(imgCode);
    /*
   * Because our images are cross-domain, we need to first create a new Img obj,
   * We can call getAverageRGB() on this img
   */
    const img: HTMLImageElement = new Image();
    img.src = url + '?' + new Date().getTime();
    img.setAttribute('crossOrigin', 'anonymous');

    img.onload = () => {
      const rgb: ImgRGB = this.coreService.getAverageRGB(img);
      const containerEl: HTMLElement = document.getElementById('game-img-container');
      const childEl: Element = containerEl.children[0];

      /*
      * Set container element background to the color we just calculated
      */
      this.renderer.setStyle(childEl, 'background-color', 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')');
    };
  }

  /*
  * If image does not exist, load default game tile
  */
  checkImgExists(imgCode: string): void {
    this.imgSrc = this.coreService.getImagePath(imgCode);
  }

  getCloseIcon(path: string): string {
    const screenWidth: number = this.coreService.getScreenWidthFromWindow();
    if (screenWidth > 700) {
      return '/assets/icons/close-dark.svg';
    } else {
      return path;
    }
  }

  gameOpenedFromSlider(isOpenedFromSlider: boolean): void {
    if(isOpenedFromSlider) {
      this.isOpenedFromSliderAndModalOpened = true;
    }
  }

  fixIncorrectImgSize(imgCode: string): boolean {
    /*
    * Hack until img sizes are fixed in scontent
    */
    return (
      imgCode === 'PMROULETTE' ||
      imgCode === 'PMBLACKJACKLOBBY' ||
      imgCode === 'PMGAMESSHOWSLOBBY' ||
      imgCode === 'PMBACCARATLOBBY'
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if(window.history.state && window.history.state.hasOwnProperty('modal')) {
      if(!this.coreService.isModalOpenedByAriaLabel('search-modal-title')) {
        if(!this.isOpenedFromSliderAndModalOpened) {
          history.back();
        }
      }
    }
  }
}
